import React, { useState } from "react";
import { FaLanguage, FaRegUser } from "react-icons/fa6";
import { IoMdHome } from "react-icons/io";
import { FiShoppingCart } from "react-icons/fi";
import { Link, NavLink } from "react-router-dom";
import { AiOutlineLogin } from "react-icons/ai";
import { useSelector } from "react-redux";
import { languageHelper } from "../../config/helperFunctions";

function BottomNav({ handleLangChange, language }) {
  const customer = localStorage.getItem("rms-customer");
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const cart = useSelector((state) => state.products.cart);

  return (
    <nav className="flex items-center justify-between py-3 px-5 fixed bottom-0 left-0 z-20 w-full bg-white lg:hidden border-t">
      <NavLink
        to="/"
        className="active router-link-exact-active text-primary flex flex-col items-center gap-1"
        aria-current="page"
      >
        <IoMdHome className="text-4xl" />
        <span className="text-xs capitalize">Home</span>
      </NavLink>
      <button
        className="flex flex-col items-center gap-1 relative"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <FaLanguage className="text-4xl" />
        <span className="text-xs capitalize">Language</span>
        {dropdownOpen && (
          <div className="absolute bottom-16 left-0 bg-white shadow-lg w-36 border rounded-lg p-1">
            <ul>
              <li>
                <button
                  onClick={() => {
                    handleLangChange("text_en");
                    setDropdownOpen(false);
                  }}
                  className="w-full px-1 py-2 text-start hover:bg-gray-100 rounded"
                >
                  {languageHelper(language, defaultLang, "english") ||
                    "English"}
                </button>
              </li>
              <hr />
              <li>
                <button
                  onClick={() => {
                    handleLangChange("text_ar");
                    setDropdownOpen(false);
                  }}
                  className="w-full px-1 py-2 text-start hover:bg-gray-100 rounded"
                >
                  {languageHelper(language, defaultLang, "arabic") || "Arabic"}
                </button>
              </li>
            </ul>
          </div>
        )}
      </button>
      <Link
        to={"mycart"}
        className="bg-w-btn text-base w-16 h-16 leading-[48px] text-center rounded-full -mt-16 text-w-btn-text grid place-items-center relative"
      >
        {cart.length > 0 && (
          <span className="bg-w-btn-text text-w-btn border border-w-border rounded-full text-xs absolute top-1 right-1 size-4 text-center">
            {cart.length}
          </span>
        )}
        <FiShoppingCart className="text-4xl" />
      </Link>
      <NavLink href="#/offers" className="flex flex-col items-center gap-1">
        <img
          width="40"
          height="40"
          src="/assets/order-track.svg"
          alt="track-order"
        />
        <span className="text-xs capitalize">Track Order</span>
      </NavLink>
      {customer ? (
        <NavLink to="/dashboard" className="flex flex-col items-center gap-1">
          <FaRegUser className="text-4xl" />
          <span className="text-xs capitalize">My Account</span>
        </NavLink>
      ) : (
        <NavLink to={"login"} className="flex flex-col items-center gap-1">
          <AiOutlineLogin className="text-4xl" />
          <span className="text-xs capitalize">Login</span>
        </NavLink>
      )}
    </nav>
  );
}

export default BottomNav;
